import { render, staticRenderFns } from "./HedgingContractTransactionAgreement.vue?vue&type=template&id=8f6747f6&scoped=true&"
import script from "./HedgingContractTransactionAgreement.vue?vue&type=script&lang=js&"
export * from "./HedgingContractTransactionAgreement.vue?vue&type=script&lang=js&"
import style0 from "./HedgingContractTransactionAgreement.vue?vue&type=style&index=0&id=8f6747f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6747f6",
  null
  
)

export default component.exports